const invoiceDisplayQuantity = detail => Number((detail && detail.qty) || 0);

const totalInvoiceBoxes = details =>
  (details || []).reduce(
    (sum, detail) => sum + invoiceDisplayQuantity(detail),
    0,
  );

module.exports = { invoiceDisplayQuantity, totalInvoiceBoxes };
